import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExcluirAtividadeAltExec = ({ data }) => {
  const {
    request: excluirRequest,
    data: excluirData,
    errors: excluirErrors,
    isLoading: excluirIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (excluirIsLoading) return;

    if (!excluirData && !excluirErrors) return;

    if (excluirData) {
      toast.success("Atividade excluída com sucesso!");
      window.location.reload();
    }
  }, [excluirData, excluirErrors, excluirIsLoading]);

  const excluirAtividade = () => {
    excluirRequest(apiRoutes.fiscalizacao.alteracaoexecutor.excluirAtividade, {
      sequencialAlteracaoExecutor: data.sqAlteracaoExecutor,
      sequencialAndamento: data.sequencialUltimoAndamento,
    });
  };

  return { excluirAtividade, excluirErrors, excluirIsLoading };
};

export default useExcluirAtividadeAltExec;
